"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Regex Explained:
 * Match at least one number:						(?=.*\d)
 * Match at least one lower case character: 		(?=.*[a-z])
 * Match at least one upper case character: 		(?=.*[A-Z])
 * Match only these specific characters:			[a-zA-Z\d$*%!.,^]
 * Match only when between 8 and 40 characters: 	{8,40}
 */

var DefaultConfig = {
  componentName: 'fuse-password',
  passwordRegEx: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])^[a-zA-Z\d$*%!.,^]{8,40}$/,
  passwordStrengthRegEx: [{
    validation: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])^[a-zA-Z\d$*%!.,^]{8,40}$/
  }, {
    validation: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])^[a-zA-Z\d$*%!.,^]{10,40}$/
  }, {
    validation: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])^[a-zA-Z\d$*%!.,^]{12,40}$/
  }, {
    validation: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*%!.,^])^[a-zA-Z\d$*%!.,^]{14,40}$/
  }],
  passwordValidationErrors: {
    empty: 'Please enter a valid password',
    specialCharacters: 'We can only accept the following special characters $ . , ! % ^ *',
    minLength: 'Your password must be at least 8 characters long',
    maxLength: "Your password can't be more than 40 characters",
    numbers: 'Please make sure there is at least 1 number',
    lowerCase: 'Please make sure there is at least 1 lowercase letter',
    upperCase: 'Please make sure there is at least 1 uppercase letter'
  },
  passwordModalHintsConfig: ["Don\u2019t use family names or your email address, these are easy for others to guess, especially if you use your own name.", "Try not to use a password that you use on other sites.", "Avoid repetition and sequences such as \u2018abcdef\u2019 or \u2018123456\u2019.", "Replace letters with symbols but don\u2019t simply misspell common words.", "Try including one of the following special characters $ . , ! % ^ * to make your password even stronger."],
  passwordHints: [{
    text: 'Must have between 8 and 40 characters',
    validation: /^.{8,40}$/
  }, {
    text: 'Must have at least one lower case letter',
    validation: /[a-z]/
  }, {
    text: 'Must have at least one upper case letter',
    validation: /[A-Z]/
  }, {
    text: 'Must have at least one number',
    validation: /[\d]/
  }],
  passwordRequirementsListConfig: [{
    id: 1,
    label: 'Must have between 8 and 40 characters',
    validate: function validate(value) {
      return value.length >= 8;
    }
  }, {
    id: 2,
    label: 'Must have at least one lower case letter',
    validate: function validate(value) {
      return /[a-z]/.test(value);
    }
  }, {
    id: 3,
    label: 'Must have at least one upper case letter',
    validate: function validate(value) {
      return /[A-Z]/.test(value);
    }
  }, {
    id: 4,
    label: 'Must have at least one number',
    validate: function validate(value) {
      return /\d/.test(value);
    }
  }]
};
var _default = exports["default"] = DefaultConfig;